var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c("div", { staticClass: "panel-body no-padding" }, [
          _c(
            "div",
            { staticClass: "table-responsive no-overflow" },
            [
              _c(
                "table-editable-list",
                {
                  attrs: {
                    columns: _vm.columns,
                    "show-select": false,
                    "show-actions": false,
                    tableClass: { "margin-bottom-0": true, "no-border": true }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "data-row" },
                    [
                      _vm._l(_vm.department.COURSES, function(course, idx) {
                        return [
                          _c("table-list-row", {
                            key: "course_" + course.COURSE_DESC,
                            attrs: {
                              columns: _vm.columns,
                              rowdata: course,
                              rowIndex: idx,
                              showActions: false
                            }
                          })
                        ]
                      })
                    ],
                    2
                  )
                ],
                2
              )
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }